/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface SplitAndPayDigitalBillDtoV2
 */
export interface SplitAndPayDigitalBillDtoV2 {
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    orderLineQuantityMap?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    tipAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    discountCode?: string;
    /**
     * 
     * @type {number}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    serviceChargePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    placementId?: number;
    /**
     * 
     * @type {string}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    deviceId: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SplitAndPayDigitalBillDtoV2
     */
    dynamicFields?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SplitAndPayDigitalBillDtoV2 interface.
 */
export function instanceOfSplitAndPayDigitalBillDtoV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function SplitAndPayDigitalBillDtoV2FromJSON(json: any): SplitAndPayDigitalBillDtoV2 {
    return SplitAndPayDigitalBillDtoV2FromJSONTyped(json, false);
}

export function SplitAndPayDigitalBillDtoV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitAndPayDigitalBillDtoV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'orderLineQuantityMap': !exists(json, 'orderLineQuantityMap') ? undefined : json['orderLineQuantityMap'],
        'tipAmount': !exists(json, 'tipAmount') ? undefined : json['tipAmount'],
        'discountCode': !exists(json, 'discountCode') ? undefined : json['discountCode'],
        'serviceChargePercentage': !exists(json, 'serviceChargePercentage') ? undefined : json['serviceChargePercentage'],
        'placementId': !exists(json, 'placementId') ? undefined : json['placementId'],
        'deviceId': json['deviceId'],
        'dynamicFields': !exists(json, 'dynamicFields') ? undefined : json['dynamicFields'],
    };
}

export function SplitAndPayDigitalBillDtoV2ToJSON(value?: SplitAndPayDigitalBillDtoV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'orderLineQuantityMap': value.orderLineQuantityMap,
        'tipAmount': value.tipAmount,
        'discountCode': value.discountCode,
        'serviceChargePercentage': value.serviceChargePercentage,
        'placementId': value.placementId,
        'deviceId': value.deviceId,
        'dynamicFields': value.dynamicFields,
    };
}

